import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
      staticClass: "filter-list-item primary--text",
      on: {
        click: function ($event) {
          return _vm.$emit("click")
        },
      },
    },
    [
      _c("div", { staticClass: "icon-secondary--text mr-4", class: _vm.icon }),
      _vm._v(" "),
      _c("div", { staticClass: "mr-4 w-100" }, [
        _c("div", { staticClass: "text-body-1 text--text" }, [
          _vm._v("\n      " + _vm._s(_vm.title) + "\n    "),
        ]),
        _vm._v(" "),
        _vm.subtitle
          ? _c("div", { staticClass: "text-body-2 text-secondary--text" }, [
              _vm._v("\n      " + _vm._s(_vm.subtitle) + "\n    "),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "icon-secondary--text ui-icon-arrow-right" }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }